import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  go(event) {
    const url = event.target.value
    if (url) window.Turbo.visit(url)
  }
}
